import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);
const EST_COLORS = { prospecto:'#6366f1', trial:'#fbbf24', activo:'#34d399', suspendido:'#f97316', cancelado:'#f87171' };

export default function AdminClienteDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalSusc, setModalSusc] = useState(false);
  const [modalPago, setModalPago] = useState(false);
  const [modalAct, setModalAct] = useState(false);
  const [modalUpgrade, setModalUpgrade] = useState(null);
  const [reenviando, setReenviando] = useState(false);

  const cargar = () => {
    api.get(`/admin/clientes/${id}`).then(r => setCliente(r.data)).finally(() => setLoading(false));
  };
  useEffect(cargar, [id]);

  if (loading) return <div style={{ color: 'var(--text-3)', padding: 40, textAlign: 'center' }}>Cargando...</div>;
  if (!cliente) return <div style={{ color: '#ef4444', padding: 40 }}>Cliente no encontrado</div>;

  const estColor = EST_COLORS[cliente.estado] || '#64748b';

  return (
    <div style={{ padding: 28, color: 'var(--text-1s)' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 28 }}>
        <button onClick={() => navigate('/superadmin/clientes')} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-3)', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontSize: 13 }}>← Volver</button>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>{cliente.empresa}</h1>
            <span style={{ padding: '3px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: estColor + '22', color: estColor, textTransform: 'capitalize' }}>{cliente.estado}</span>
          </div>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 13 }}>{cliente.email} · {cliente.ciudad} · NIT: {cliente.nit || 'N/A'}</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => setModalPago(true)} style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#22d3ee20', color: '#22d3ee', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ Pago</button>
          <button onClick={() => setModalSusc(true)} style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ Suscripción</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 20 }}>
        {/* Info card */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <InfoCard title="Información">
            <InfoRow label="Contacto" value={cliente.contacto_nombre || '-'} />
            <InfoRow label="Cargo" value={cliente.contacto_cargo || '-'} />
            <InfoRow label="Teléfono" value={cliente.telefono || '-'} />
            <InfoRow label="País" value={cliente.pais} />
            <InfoRow label="Registrado" value={cliente.created_at?.split('T')[0]} />
            {cliente.notas && <InfoRow label="Notas" value={cliente.notas} />}
          </InfoCard>

          {/* Acceso del cliente */}
          <InfoCard title="Acceso SaturnPRO">
            {cliente.admin_user ? (
              <>
                <InfoRow label="Usuario" value={<span style={{ color: '#38bdf8', fontFamily: 'monospace' }}>{cliente.admin_user.email}</span>} />
                <InfoRow label="Nombre" value={cliente.admin_user.nombre} />
                <InfoRow label="Estado" value={
                  <span style={{ color: cliente.admin_user.activo ? '#4ade80' : '#f87171' }}>
                    {cliente.admin_user.activo ? 'Activo' : 'Inactivo'}
                  </span>
                } />
                <InfoRow label="Creado" value={cliente.admin_user.created_at?.split('T')[0]} />
                <button
                  onClick={async () => {
                    setReenviando(true);
                    try {
                      await api.post(`/admin/clientes/${id}/reenviar-credenciales`);
                      toast.success('Credenciales reenviadas por email');
                    } catch (e) {
                      toast.error(e.response?.data?.error || 'Error al reenviar');
                    } finally { setReenviando(false); }
                  }}
                  disabled={reenviando}
                  style={{ marginTop: 10, width: '100%', padding: '8px', borderRadius: 7, border: 'none', background: '#1e3a8a', color: '#93c5fd', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                >
                  {reenviando ? 'Enviando...' : 'Reenviar credenciales por email'}
                </button>
              </>
            ) : (
              <p style={{ color: 'var(--text-4)', fontSize: 13, lineHeight: 1.6 }}>
                Sin usuario admin creado. Se crea automáticamente al asignar una suscripción activa o trial.
              </p>
            )}
          </InfoCard>

          {/* Active subscriptions summary */}
          <InfoCard title="Suscripción Activa">
            {cliente.suscripciones?.filter(s => s.estado === 'activo').map(s => (
              <div key={s.id} style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ color: s.plan_color, fontWeight: 700 }}>{s.plan_nombre}</span>
                  <button onClick={() => setModalUpgrade(s)} style={{ border: 'none', background: '#6366f120', color: '#818cf8', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12 }}>Upgrade</button>
                </div>
                <InfoRow label="Sillas" value={s.sillas} />
                <InfoRow label="Precio" value={fmt(s.precio_pactado) + '/mes'} />
                <InfoRow label="Ciclo" value={s.ciclo} />
                <InfoRow label="Vence" value={s.fecha_fin || 'Sin fecha'} />
              </div>
            ))}
            {!cliente.suscripciones?.filter(s => s.estado === 'activo').length && (
              <p style={{ color: 'var(--text-4)', fontSize: 13 }}>Sin suscripción activa</p>
            )}
          </InfoCard>
        </div>

        {/* Right side */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Payments */}
          <InfoCard title="Últimos Pagos">
            {cliente.pagos?.length ? (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr>
                    {['Fecha','Concepto','Monto','Método','Estado'].map(h => (
                      <th key={h} style={{ textAlign: 'left', color: 'var(--text-3)', fontWeight: 600, padding: '4px 8px', fontSize: 11 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cliente.pagos.map(p => (
                    <tr key={p.id} style={{ borderTop: '1px solid #1e293b' }}>
                      <td style={{ padding: '8px 8px', color: 'var(--text-2)' }}>{p.fecha}</td>
                      <td style={{ padding: '8px 8px', color: 'var(--text-1s)' }}>{p.concepto || '-'}</td>
                      <td style={{ padding: '8px 8px', color: '#22d3ee', fontWeight: 600 }}>{fmt(p.monto)}</td>
                      <td style={{ padding: '8px 8px', color: 'var(--text-2)' }}>{p.metodo}</td>
                      <td style={{ padding: '8px 8px' }}>
                        <span style={{ color: p.estado === 'pagado' ? '#34d399' : p.estado === 'pendiente' ? '#fbbf24' : '#f87171', fontSize: 11 }}>{p.estado}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : <p style={{ color: 'var(--text-4)', fontSize: 13 }}>Sin pagos registrados</p>}
          </InfoCard>

          {/* Activities */}
          <InfoCard title={<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span>Actividades CRM</span>
            <button onClick={() => setModalAct(true)} style={{ border: 'none', background: '#6366f120', color: '#818cf8', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12 }}>+ Nueva</button>
          </div>}>
            {cliente.actividades?.length ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {cliente.actividades.map(a => (
                  <div key={a.id} style={{ padding: '10px 12px', background: 'var(--bg-app)', borderRadius: 8, border: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ color: 'var(--text-1s)', fontWeight: 600, fontSize: 13 }}>{a.titulo}</span>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <span style={{ fontSize: 11, color: 'var(--text-3)' }}>{a.fecha}</span>
                        <TipoBadge tipo={a.tipo} />
                      </div>
                    </div>
                    {a.descripcion && <p style={{ margin: 0, color: 'var(--text-3)', fontSize: 12 }}>{a.descripcion}</p>}
                    {a.resultado && <p style={{ margin: '4px 0 0', color: '#34d399', fontSize: 12 }}>→ {a.resultado}</p>}
                  </div>
                ))}
              </div>
            ) : <p style={{ color: 'var(--text-4)', fontSize: 13 }}>Sin actividades</p>}
          </InfoCard>
        </div>
      </div>

      {modalSusc && <SuscripcionModal clienteId={id} onClose={() => setModalSusc(false)} onSaved={() => { setModalSusc(false); cargar(); }} />}
      {modalPago && <PagoModal clienteId={id} suscripciones={cliente.suscripciones} onClose={() => setModalPago(false)} onSaved={() => { setModalPago(false); cargar(); }} />}
      {modalAct && <ActividadModal clienteId={id} onClose={() => setModalAct(false)} onSaved={() => { setModalAct(false); cargar(); }} />}
      {modalUpgrade && <UpgradeModal suscripcion={modalUpgrade} onClose={() => setModalUpgrade(null)} onSaved={() => { setModalUpgrade(null); cargar(); }} />}
    </div>
  );
}

const InfoCard = ({ title, children }) => (
  <div style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 20, border: '1px solid var(--border)' }}>
    <h3 style={{ margin: '0 0 14px', fontSize: 13, fontWeight: 600, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>{title}</h3>
    {children}
  </div>
);

const InfoRow = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #1e293b', fontSize: 13 }}>
    <span style={{ color: 'var(--text-3)' }}>{label}</span>
    <span style={{ color: 'var(--text-1s)' }}>{value}</span>
  </div>
);

const TIPO_COLORS = { llamada:'#22d3ee', email:'#6366f1', reunion:'#fbbf24', nota:'#94a3b8', demo:'#34d399', propuesta:'#f97316', soporte:'#a78bfa', otro:'#64748b' };
const TipoBadge = ({ tipo }) => (
  <span style={{ fontSize: 10, padding: '1px 7px', borderRadius: 10, background: (TIPO_COLORS[tipo] || '#64748b') + '22', color: TIPO_COLORS[tipo] || '#64748b' }}>{tipo}</span>
);

function SuscripcionModal({ clienteId, onClose, onSaved }) {
  const [planes, setPlanes] = useState([]);
  const [form, setForm] = useState({ plan_id: '', sillas: '', fecha_inicio: new Date().toISOString().split('T')[0], fecha_fin: '', ciclo: 'mensual', precio_pactado: '', estado: 'activo' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  useEffect(() => { api.get('/admin/planes').then(r => setPlanes(r.data)).catch(() => {}); }, []);

  const guardar = async () => {
    setSaving(true);
    try {
      await api.post('/admin/suscripciones', { ...form, cliente_id: clienteId, sillas: Number(form.sillas), precio_pactado: Number(form.precio_pactado) });
      toast.success('Suscripción creada');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  const planSel = planes.find(p => String(p.id) === String(form.plan_id));

  return (
    <ModalWrapper title="Nueva Suscripción" onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Plan *</label>
          <select style={inputStyle} value={form.plan_id} onChange={e => { set('plan_id', e.target.value); const p = planes.find(x => String(x.id) === e.target.value); if (p) set('precio_pactado', p.precio_mensual); }}>
            <option value="">Seleccionar plan...</option>
            {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} (máx {p.max_sillas} sillas)</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Sillas * {planSel && <span style={{ color: '#6366f1' }}>máx {planSel.max_sillas}</span>}</label>
          <input style={inputStyle} type="number" value={form.sillas} onChange={e => set('sillas', e.target.value)} placeholder="Número de sillas" />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Precio Pactado (COP) *</label>
          <input style={inputStyle} type="number" value={form.precio_pactado} onChange={e => set('precio_pactado', e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Ciclo</label>
          <select style={inputStyle} value={form.ciclo} onChange={e => set('ciclo', e.target.value)}>
            <option value="mensual">Mensual</option>
            <option value="anual">Anual</option>
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Estado</label>
          <select style={inputStyle} value={form.estado} onChange={e => set('estado', e.target.value)}>
            {['activo','trial','vencida','cancelada'].map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Fecha inicio *</label>
          <input style={inputStyle} type="date" value={form.fecha_inicio} onChange={e => set('fecha_inicio', e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Fecha fin</label>
          <input style={inputStyle} type="date" value={form.fecha_fin} onChange={e => set('fecha_fin', e.target.value)} />
        </div>
      </div>
      <ModalFooter onClose={onClose} onSave={guardar} saving={saving} />
    </ModalWrapper>
  );
}

function UpgradeModal({ suscripcion, onClose, onSaved }) {
  const [planes, setPlanes] = useState([]);
  const [form, setForm] = useState({ plan_id: String(suscripcion.plan_id), sillas: suscripcion.sillas, precio_pactado: suscripcion.precio_pactado, tipo: 'upgrade', motivo: '' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  useEffect(() => { api.get('/admin/planes').then(r => setPlanes(r.data)).catch(() => {}); }, []);

  const guardar = async () => {
    setSaving(true);
    try {
      await api.post(`/admin/suscripciones/${suscripcion.id}/upgrade`, { ...form, sillas: Number(form.sillas), precio_pactado: Number(form.precio_pactado) });
      toast.success('Upgrade aplicado');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  const planSel = planes.find(p => String(p.id) === String(form.plan_id));

  return (
    <ModalWrapper title={`Upgrade / Downgrade: ${suscripcion.plan_nombre}`} onClose={onClose}>
      <div style={{ background: 'var(--bg-app)', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: 'var(--text-3)' }}>
        Plan actual: <strong style={{ color: suscripcion.plan_color }}>{suscripcion.plan_nombre}</strong> · {suscripcion.sillas} sillas · {new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(suscripcion.precio_pactado)}/mes
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Nuevo Plan *</label>
          <select style={inputStyle} value={form.plan_id} onChange={e => { set('plan_id', e.target.value); const p = planes.find(x => String(x.id) === e.target.value); if (p) set('precio_pactado', p.precio_mensual); }}>
            {planes.map(p => <option key={p.id} value={p.id}>{p.nombre} (máx {p.max_sillas} sillas)</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Nuevas Sillas * {planSel && <span style={{ color: '#6366f1' }}>máx {planSel.max_sillas}</span>}</label>
          <input style={inputStyle} type="number" value={form.sillas} onChange={e => set('sillas', e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Nuevo Precio (COP/mes) *</label>
          <input style={inputStyle} type="number" value={form.precio_pactado} onChange={e => set('precio_pactado', e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Tipo</label>
          <select style={inputStyle} value={form.tipo} onChange={e => set('tipo', e.target.value)}>
            <option value="upgrade">Upgrade</option>
            <option value="downgrade">Downgrade</option>
            <option value="renovacion">Renovación</option>
          </select>
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Motivo</label>
          <input style={inputStyle} value={form.motivo} onChange={e => set('motivo', e.target.value)} placeholder="Razón del cambio..." />
        </div>
      </div>
      <ModalFooter onClose={onClose} onSave={guardar} saving={saving} saveLabel="Aplicar Cambio" />
    </ModalWrapper>
  );
}

function PagoModal({ clienteId, suscripciones, onClose, onSaved }) {
  const [form, setForm] = useState({ suscripcion_id: suscripciones?.find(s => s.estado === 'activo')?.id || '', monto: '', fecha: new Date().toISOString().split('T')[0], metodo: 'transferencia', referencia: '', concepto: '', estado: 'pagado' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  const guardar = async () => {
    setSaving(true);
    try {
      await api.post('/admin/pagos', { ...form, cliente_id: clienteId, monto: Number(form.monto) });
      toast.success('Pago registrado');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  return (
    <ModalWrapper title="Registrar Pago" onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Suscripción</label>
          <select style={inputStyle} value={form.suscripcion_id} onChange={e => set('suscripcion_id', e.target.value)}>
            <option value="">Sin suscripción</option>
            {(suscripciones || []).map(s => <option key={s.id} value={s.id}>{s.plan_nombre} · {s.estado}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Monto *</label>
          <input style={inputStyle} type="number" value={form.monto} onChange={e => set('monto', e.target.value)} placeholder="189000" />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Fecha *</label>
          <input style={inputStyle} type="date" value={form.fecha} onChange={e => set('fecha', e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Método</label>
          <select style={inputStyle} value={form.metodo} onChange={e => set('metodo', e.target.value)}>
            {['transferencia','tarjeta','nequi','daviplata','efectivo','otro'].map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Estado</label>
          <select style={inputStyle} value={form.estado} onChange={e => set('estado', e.target.value)}>
            {['pagado','pendiente','fallido','reembolsado'].map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Referencia</label>
          <input style={inputStyle} value={form.referencia} onChange={e => set('referencia', e.target.value)} placeholder="TRF-001" />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Concepto</label>
          <input style={inputStyle} value={form.concepto} onChange={e => set('concepto', e.target.value)} placeholder="Suscripción mensual..." />
        </div>
      </div>
      <ModalFooter onClose={onClose} onSave={guardar} saving={saving} saveLabel="Registrar Pago" />
    </ModalWrapper>
  );
}

function ActividadModal({ clienteId, onClose, onSaved }) {
  const [form, setForm] = useState({ tipo: 'llamada', titulo: '', descripcion: '', fecha: new Date().toISOString().split('T')[0], resultado: '' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  const guardar = async () => {
    setSaving(true);
    try {
      await api.post('/admin/crm/actividades', { ...form, cliente_id: clienteId });
      toast.success('Actividad registrada');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  return (
    <ModalWrapper title="Nueva Actividad" onClose={onClose}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Tipo *</label>
          <select style={inputStyle} value={form.tipo} onChange={e => set('tipo', e.target.value)}>
            {['llamada','email','reunion','nota','demo','propuesta','soporte','otro'].map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Fecha *</label>
          <input style={inputStyle} type="date" value={form.fecha} onChange={e => set('fecha', e.target.value)} />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Título *</label>
          <input style={inputStyle} value={form.titulo} onChange={e => set('titulo', e.target.value)} placeholder="Título de la actividad..." />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Descripción</label>
          <textarea style={{ ...inputStyle, minHeight: 70, resize: 'vertical' }} value={form.descripcion} onChange={e => set('descripcion', e.target.value)} />
        </div>
        <div style={{ gridColumn: '1/-1' }}>
          <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Resultado</label>
          <input style={inputStyle} value={form.resultado} onChange={e => set('resultado', e.target.value)} placeholder="¿Cuál fue el resultado?" />
        </div>
      </div>
      <ModalFooter onClose={onClose} onSave={guardar} saving={saving} saveLabel="Registrar" />
    </ModalWrapper>
  );
}

function ModalWrapper({ title, onClose, children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: 16, padding: 28, width: '100%', maxWidth: 520, border: '1px solid var(--border)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ margin: 0, fontSize: 17, color: 'var(--text-1)' }}>{title}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function ModalFooter({ onClose, onSave, saving, saveLabel = 'Guardar' }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
      <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
      <button onClick={onSave} disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{saving ? 'Guardando...' : saveLabel}</button>
    </div>
  );
}
